/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

import { of, throwError } from "rxjs";
import { AdvancedFilters } from "../../../../models/http/dashboard/advanced-filters.model";
import { ApplicationError } from "../../../../models/ui/application-error.model";
import { HttpRequestOptions } from "../../../../models/ui/http-request-options.model";
import { GET_GREEN_SCORE_RESPONSE, GET_WORST_10_EMISSIONS_RESPONSE } from "./dashboard-sci.db";

const CLASS_NAME = "DashboardSci";

export class DashboardSci {
	public static getGreenScore(options: HttpRequestOptions) {
		const filters = options.body as AdvancedFilters | undefined;
		const functionalUnit = filters?.functionalUnit;

		if (!filters?.startDate || !filters.endDate || !functionalUnit)
			return throwError(
				() =>
					new ApplicationError("Missing required parameters", CLASS_NAME, "getGreenScore")
			);

		return of(GET_GREEN_SCORE_RESPONSE);
	}

	public static getWorst10Emissions(options: HttpRequestOptions) {
		const filters = options.body as AdvancedFilters | undefined;
		const functionalUnit = filters?.functionalUnit;

		if (!filters?.startDate || !filters.endDate || !functionalUnit)
			return throwError(
				() =>
					new ApplicationError(
						"Missing required parameters",
						CLASS_NAME,
						"getWorst10Emissions"
					)
			);

		return of(GET_WORST_10_EMISSIONS_RESPONSE);
	}
}
